module.exports = __webpack_public_path__ + "static/media/price-registration-minutes.b157cdde.svg";